import React from "react";
import { View, Modal, SafeAreaView, ActivityIndicator } from "react-native";

import { colors, sizes } from "assets/constants";
import css from "styles";
import { logo } from "assets/images";
import Img from "./img";

export default function LoadingBox() {
  return (
    <Modal transparent animationType="fade">
      <SafeAreaView
        style={{
          ...css.centralElContainer,
          backgroundColor: colors.black + "99",
        }}
      >
        <View
          style={{
            width: 150,
            height: 150,
            ...css.centralElements,
            backgroundColor: colors.white,
            borderRadius: sizes.radius.lg,
          }}
        >
          <Img
            source={logo.drawerLogo}
            resizeMode="contain"
            style={{ width: 120, height: 100, top: -5 }}
          />

          <ActivityIndicator
            size={30}
            color={colors.theme}
            style={{ top: -15 }}
          />
        </View>
      </SafeAreaView>
    </Modal>
  );
}
